import { Button, Col, Container, Row } from "react-bootstrap";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import { HeadingWrapper } from "../Atomics/SectionHeader/SectionHeader";
import ThinFooter from "../Footer/ThinFooter";
import { useContext, useEffect, useState } from "react";
import AdminTable from "../Atomics/Table/AdminTable/AdminTable";
import { boxFetcher, channelFetcher } from "../../api/requests";
import LoadingIndicator from "../Atomics/Loading/Loading";
import { useToaster } from "../../context/toaster";
import { useSelectedChannels } from "../../context/selectedChannels";
import { AuthContext } from "../../context/auth";
import CreateBoxModal from "./CreateBoxModal";
import Modal from "../Atomics/Modal";
import { CategoryContext } from "../../context/categories";
import { TagsContext } from "../../context/tag";

const BoxManagement = () => {
  const [loading, setLoading] = useState({
    all: false,
    save: false,
  });
  const [data, setData] = useState([]);
  const [specialVideosAdjusted, setSpecialVideosAdjusted] = useState(false);
  const [specialChannelsAdjusted, setSpecialChannelsAdjusted] = useState(false);
  const { addMessage } = useToaster();
  const [update, setUpdate] = useState(false);
  const [locations, setLocations] = useState([]);
  const { selectedChannels, resetChannelArray, isChannelSelected } =
    useSelectedChannels();
  const { user } = useContext(AuthContext);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [showDelModal, setShowDelModal] = useState(false);
  const [selectedRowToDelete, setSelectedRowToDelete] = useState(null);
  const { categories } = useContext(CategoryContext);
  const { tags } = useContext(TagsContext);

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const columns = [
    { key: "box_name", label: "نام باکس" },
    { key: "name_in_view", label: "نام نمایشی" },
    { key: "box_priority", label: "ترتیب نمایش" },
    { key: "item_count", label: "تعداد کارت ها" },
    { key: "box_location_name", label: "مکان" },
    { key: "category_name", label: "دسته بندی" },
    { key: "tag_name", label: "تگ" },
    { key: "content_type", label: "نوع محتوا" },
    { key: "cach_time", label: "مدت کش" },
    { key: "box_item_type", label: "مقداردهی" },
    { key: "status", label: "وضعیت" },
  ];

  const handleEditSave = async (updatedData) => {
    setLoading((prevVal) => ({ ...prevVal, save: true }));

    try {
      const res = await boxFetcher.edit(updatedData.id, {
        id: updatedData.id,
        box_name: updatedData.box_name,
        name_in_view: updatedData.name_in_view,
        box_priority: updatedData.box_priority,
        content_type: updatedData.content_type,
        item_count: updatedData.item_count,
        status: updatedData.status,
        box_location: updatedData.box_location_id,
        categorys: updatedData.category_id,
        tags: updatedData.tag_id,
        cach_time: updatedData.cach_time,
        box_item_type: updatedData.box_item_type,
      });

      if (res.message) {
        showToast("success", res.message);

        if (selectedChannels?.length > 0) {
          const channelPromises = selectedChannels.map((item) => {
            return channelFetcher.channelDescriptionEdit(
              {
                is_favorite: isChannelSelected(item.id) ? false : true,
                supervisor_to_favorited: user.user_id,
                name: item.name,
                owner: item.owner,
              },
              item.id
            );
          });

          try {
            const channelResponses = await Promise.all(channelPromises);

            resetChannelArray();

            // showToast("success", "Videos added successfully!");
          } catch (channelError) {
            console.error("Error adding videos:", channelError);
          }
        } else {
          // showToast("info", "No videos selected.");
        }

        setUpdate(!update);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading((prevVal) => ({ ...prevVal, save: false }));
    }
  };

  const handleDelete = async (row) => {
    setSelectedRowToDelete(row);
    setShowDelModal(true);
  };

  const handleDelApprove = async (row) => {
    try {
      const res = await boxFetcher.deleteBox(row.id);

      if (res.message) {
        showToast("success", res.message);
        setUpdate(!update);
      }
    } catch (err) {
      showToast("error", err ?? "خطایی رخ داده است، دوباره تلاش کنید.");
      console.warn(err);
    } finally {
      setShowDelModal(false);
    }
  };

  const handleCreate = () => {
    setIsCreateModalOpen(true);
  };

  const handleCreateSubmit = async (newBox) => {
    try {
      const res = await boxFetcher.post({
        ...newBox,
        box_location: newBox.box_location_id,
      });

      if (res.id) {
        const selectedCategory = categories.find(
          (cat) => cat.id === newBox.categorys
        );
        const selectedTag = tags?.results?.find(
          (tag) => tag.id === Number(newBox.tags)
        );

        const newItem = {
          ...newBox,
          id: res.id,
          selectedLoc:
            locations.find((loc) => loc.id === newBox.box_location_id)?.name ||
            "",
          selectedCat: selectedCategory?.name || "",
          category_id: selectedCategory?.id || null,
          category_name: selectedCategory?.name || "",
          selectedTag: selectedTag?.name || "",
          tag_id: selectedTag?.id || null,
          tag_name: selectedTag?.name || "",
          selectedContentType: newBox.content_type,
          selectedBoxItemType:
            newBox.box_item_type === "by hand" ? "دستی" : "اتوماتیک",
          box_location_name:
            locations.find((loc) => loc.id === newBox.box_location_id)?.name ||
            "",
        };

        setData((prev) => [...prev, newItem]);
      }
    } catch (err) {
      showToast("error", err.response?.data?.detail || "خطا در ایجاد باکس");
      console.error(err);
    } finally {
      setIsCreateModalOpen(false);
    }
  };

  const getBoxes = async () => {
    setLoading((prevVal) => ({ ...prevVal, all: true }));

    try {
      const res = await boxFetcher.getAll();

      const formatedRes = res.results.map((item) => ({
        id: item.id,
        box_name: item.box_name,
        name_in_view: item.name_in_view,
        box_priority: item.box_priority,
        content_type: item.content_type,
        item_count: item.item_count,
        status: item.status,
        box_location_id: item.box_location.id,
        box_location_name: item.box_location.name,
        selectedLoc: item.box_location.name,
        category_name: item.categorys.name,
        category_id: item.categorys.id,
        selectedCat: item.categorys.name,
        tag_name: item.tags.name,
        tag_id: item.tags.id,
        selectedTag: item.tags.name,
        selectedContentType: item.content_type,
        cach_time: item.cach_time,
        box_item_type: item.box_item_type,
        selectedBoxItemType:
          item.box_item_type === "by hand" ? "دستی" : "اتوماتیک",
      }));

      // Ensure both "ویدئوهای ویژه" and "کانال های ویژه" show at least 7 items
      let updatedRes = formatedRes;

      const needAdjustVideos =
        !specialVideosAdjusted &&
        updatedRes?.some(
          (item) => item.box_name === "ویدئوهای ویژه" && item.item_count < 7
        );

      if (needAdjustVideos) {
        const specials = updatedRes.filter(
          (item) => item.box_name === "ویدئوهای ویژه" && item.item_count < 7
        );

        try {
          await Promise.all(
            specials.map((row) =>
              boxFetcher.edit(row.id, {
                id: row.id,
                box_name: row.box_name,
                name_in_view: row.name_in_view,
                box_priority: row.box_priority,
                content_type: row.content_type,
                item_count: 7,
                status: row.status,
                box_location: row.box_location_id,
                categorys: row.category_id,
                tags: row.tag_id,
                cach_time: row.cach_time,
                box_item_type: row.box_item_type,
              })
            )
          );

          updatedRes = updatedRes.map((it) =>
            it.box_name === "ویدئوهای ویژه" && it.item_count < 7
              ? { ...it, item_count: 7 }
              : it
          );
          setSpecialVideosAdjusted(true);
        } catch (editErr) {
          console.warn("Failed to auto-adjust special videos item_count", editErr);
        }
      }

      const needAdjustChannels =
        !specialChannelsAdjusted &&
        updatedRes?.some(
          (item) => item.box_name === "کانال های ویژه" && item.item_count < 7
        );

      if (needAdjustChannels) {
        const specialsCh = updatedRes.filter(
          (item) => item.box_name === "کانال های ویژه" && item.item_count < 7
        );

        try {
          await Promise.all(
            specialsCh.map((row) =>
              boxFetcher.edit(row.id, {
                id: row.id,
                box_name: row.box_name,
                name_in_view: row.name_in_view,
                box_priority: row.box_priority,
                content_type: row.content_type,
                item_count: 7,
                status: row.status,
                box_location: row.box_location_id,
                categorys: row.category_id,
                tags: row.tag_id,
                cach_time: row.cach_time,
                box_item_type: row.box_item_type,
              })
            )
          );

          updatedRes = updatedRes.map((it) =>
            it.box_name === "کانال های ویژه" && it.item_count < 7
              ? { ...it, item_count: 7 }
              : it
          );
          setSpecialChannelsAdjusted(true);
        } catch (editErr) {
          console.warn("Failed to auto-adjust special channels item_count", editErr);
        }
      }

      setData(updatedRes);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading((prevVal) => ({ ...prevVal, all: false }));
    }
  };

  const handleCheckboxChange = (index) => {
    const updatedRows = data.map((item, i) => {
      if (i === index) {
        let nextState;
        if (item.status === true) {
          nextState = false;
        } else if (item.status === null) {
          nextState = false;
        } else {
          nextState = true;
        }

        return {
          ...item,
          status: nextState,
        };
      }
      return item;
    });

    setData(updatedRows);
  };

  const getBoxLocations = async () => {
    setLoading((prevVal) => ({ ...prevVal, all: true }));

    try {
      const res = await boxFetcher.getAllBoxLocations();

      if (res.count > 0) setLocations(res.results);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading((prevVal) => ({ ...prevVal, all: false }));
    }
  };

  const handleLocationChange = (rowId, newLocation) => {
    const updatedData = data.map((item) =>
      item.id === rowId
        ? {
            ...item,
            box_location_id: newLocation.id,
            selectedLoc: newLocation.name,
          }
        : item
    );
    setData(updatedData);
  };

  const handleCategoryChange = (rowId, newCategory) => {
    const updatedData = data.map((item) =>
      item.id === rowId
        ? {
            ...item,
            category_id: newCategory.id,
            selectedCat: newCategory.name,
          }
        : item
    );
    setData(updatedData);
  };

  const handleTagChange = (rowId, newTag) => {
    const updatedData = data.map((item) =>
      item.id === rowId
        ? {
            ...item,
            tag_id: newTag.id,
            selectedTag: newTag.name,
          }
        : item
    );
    setData(updatedData);
  };

  const handleContentTypeChange = (rowId, newContentType) => {
    const updatedData = data.map((item) =>
      item.id === rowId
        ? {
            ...item,
            content_type: newContentType,
            selectedContentType: newContentType,
          }
        : item
    );
    setData(updatedData);
  };

  const handleBoxItemTypeChange = (rowId, newBoxItemType) => {
    console.warn(newBoxItemType);
    const updatedData = data.map((item) =>
      item.id === rowId
        ? {
            ...item,
            box_item_type: newBoxItemType.en,
            selectedBoxItemType: newBoxItemType.fa,
          }
        : item
    );
    setData(updatedData);
  };

  useEffect(() => {
    getBoxes();
    getBoxLocations();
  }, [update]);

  return (
    <ContentWrapper>
      <Container
        fluid
        className="upload-details text-right"
        style={{
          paddingLeft: "30px",
          paddingRight: "30px",
          minHeight: "calc(100vh - 123px)",
        }}
      >
        <div
          style={{
            paddingTop: "30px",
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        >
          <Row>
            <Col>
              <div className="float-right">
                <HeadingWrapper heading="مدیریت باکس ها" />
              </div>
            </Col>
          </Row>

          <Row className="py-1">
            {loading.all ? (
              <LoadingIndicator />
            ) : (
              <AdminTable
                columns={columns}
                data={data}
                onSave={handleEditSave}
                onDelete={handleDelete}
                onCreate={handleCreate}
                handleCheckboxChange={handleCheckboxChange}
                saveLoading={loading.save}
                boxLocs={locations}
                onLocationChange={handleLocationChange}
                onCategoryChange={handleCategoryChange}
                onTagChange={handleTagChange}
                onContentTypeChange={handleContentTypeChange}
                onBoxItemTypeChange={handleBoxItemTypeChange}
              />
            )}
          </Row>
        </div>
      </Container>

      <CreateBoxModal
        show={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        onSubmit={handleCreateSubmit}
        locations={locations}
      />

      <Modal isOpen={showDelModal} onClose={() => setShowDelModal(false)}>
        <p style={{ paddingTop: "15px", fontSize: "18px", width: "100%" }}>
          از حذف این آیتم مطمئن هستید؟
        </p>
        <div style={{ display: "flex", gap: "5px", width: "100%" }}>
          <Button
            style={{
              fontSize: "15px",
              padding: "2px 8px",
              height: "fit-content",
            }}
            onClick={() => handleDelApprove(selectedRowToDelete)}
          >
            بله
          </Button>
          <Button
            style={{
              fontSize: "15px",
              padding: "2px 8px",
              height: "fit-content",
            }}
            variant="danger"
            onClick={() => setShowDelModal(false)}
          >
            خیر
          </Button>
        </div>
      </Modal>

      <ThinFooter />
    </ContentWrapper>
  );
};

export default BoxManagement;
